import apptracker from '@utils/sensor/apptracker';
import { Space } from 'antd';
import React from 'react';
import WidgetCardWrapper from './WidgetCardWrapper';
import RemoveWidget from '../control/RemoveWidget';
import { useWidget } from '../state/dashboard';
import { StyledResult } from './styled';

const RemoveWrapper = ({ wid }) => {
  const widgetHandler = useWidget({ wid });
  return (
    <Space>
      <RemoveWidget onClick={widgetHandler.remove} />
    </Space>
  );
};

interface WidgetErrorBoundaryProps {
  wid: string;
  children: React.ReactNode;
}

interface WidgetErrorBoundaryState {
  error: Error | null;
  errorInfo: React.ErrorInfo | null;
}

class WidgetErrorBoundary extends React.Component<
  WidgetErrorBoundaryProps,
  WidgetErrorBoundaryState
> {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });

    apptracker('error-boundary', { ...this.state });
  }

  render() {
    if (this.state.errorInfo) {
      // Error path
      return (
        <WidgetCardWrapper
          wid={this.props.wid}
          title={'Error'}
          style={{ gridRow: 'span 7' }}
          extra={<RemoveWrapper wid={this.props.wid} />}
        >
          <StyledResult status="warning" subTitle="Something went wrong." />
        </WidgetCardWrapper>
      );
    }
    // Normally, just render children
    return <React.Fragment key="error-boundary">{this.props.children}</React.Fragment>;
  }
}

export default WidgetErrorBoundary;
